import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function AdminGuard() {
  const location = useLocation();
  const apiKey = localStorage.getItem("admin-api-key");

  if (!apiKey) {
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
